module.exports = __webpack_public_path__ + "img/battery_blue.72e5d003.svg";